import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["onFileManagerClose", "onFileManagerOpen", "onSelectFile", "picker", "filterType", "filteredExtensions"];
import { Fragment, Component } from 'react';
import shallowCompare from 'react-addons-shallow-compare';
import PickersContext from 'ContentComponents/context/PickersContext';
import { DrawerTypes, PickerTypes } from 'file-manager-components/constants';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function withFileManager(WrappedComponent) {
  class FileManagerWrapper extends Component {
    constructor(props) {
      super(props);
      this.onFileManagerOpen = this.onFileManagerOpen.bind(this);
      this.onFileManagerClose = this.onFileManagerClose.bind(this);
      this.onSelectFile = this.onSelectFile.bind(this);
      this.state = {
        isFileManagerOpen: false,
        options: {}
      };
    }
    shouldComponentUpdate(nextProps, nextState) {
      return shallowCompare(this, nextProps, nextState);
    }
    onFileManagerOpen(fileSelectedCallback, options = {}) {
      this.setState({
        isFileManagerOpen: true,
        fileSelectedCallback,
        options
      });
    }
    onFileManagerClose() {
      this.setState({
        isFileManagerOpen: false,
        options: {}
      });
    }
    onSelectFile(response) {
      this.onFileManagerClose();
      if (this.state.fileSelectedCallback) {
        this.state.fileSelectedCallback(response);
      }
    }
    render() {
      const _this$props = this.props,
        {
          onFileManagerClose,
          onFileManagerOpen,
          onSelectFile,
          picker,
          filterType,
          filteredExtensions
        } = _this$props,
        rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
      const {
        initialPanel
      } = this.state.options;
      return /*#__PURE__*/_jsxs(Fragment, {
        children: [/*#__PURE__*/_jsx(WrappedComponent, Object.assign({
          filteredExtensions: filteredExtensions,
          onFileManagerClose: onFileManagerClose || this.onFileManagerClose,
          onFileManagerOpen: onFileManagerOpen || this.onFileManagerOpen
        }, rest)), this.state.isFileManagerOpen && /*#__PURE__*/_jsx(PickersContext.Consumer, {
          children: ({
            FilePicker
          }) => {
            if (!FilePicker) {
              throw new Error('withFileManager requires FilePicker to be provided in PickersContext.');
            }
            return /*#__PURE__*/_jsx(FilePicker, {
              onClose: onFileManagerClose || this.onFileManagerClose,
              onSelect: onSelectFile || this.onSelectFile,
              pickerType: PickerTypes.SIDE_MODAL,
              type: picker,
              filterType: filterType,
              filteredExtensions: filteredExtensions,
              initialPanel: initialPanel,
              renderContext: "ContentComponents-withFileManager"
            });
          }
        })]
      });
    }
  }
  FileManagerWrapper.defaultProps = {
    picker: DrawerTypes.FILE
  };
  FileManagerWrapper.wrappedComponent = WrappedComponent;
  return FileManagerWrapper;
}